import axios from 'axios'

const languages = {
  state: {
    modal_language: false,
    modal_phrase: false
  },
  mutations: {
    setModalLanguageStatus (state, status) {
      state.modal_language = status
    },
    setModalPhraseStatus (state, status) {
      state.modal_phrase = status
    }
  },
  getters: {
    getModalLanguageStatus (state) {
      return state.modal_language
    },
    getModalPhraseStatus (state) {
      return state.modal_phrase
    }
  },
  actions: {
    changeModalLanguageStatus (context, payload) {
      context.commit('setModalLanguageStatus', payload)
    },
    retrieveDetailsLanguage (context, payload) {
      return axios.get(`/api/language/${payload}`)
    },
    changeStateLanguage (context, payload) {
      if (payload.state === 0) {
        return axios.post('/api/language/change/', payload)
      } else {
        return axios.patch('/api/language/modify/', payload)
      }
    },
    modifyLanguage (context, payload) {
      return axios.patch('/api/language/modify/', payload)
    },
    registerLanguage (context, payload) {
      return axios.post('/api/language/create', { language: payload })
    },
    changeModalPhraseStatus (context, payload) {
      context.commit('setModalPhraseStatus', payload)
    },
    retrieveDetailsPhraseForm (context, payload) {
      return axios.get('/api/phrase/new')
    },
    deletePhrase (context, payload) {
      return axios.post('/api/phrase/delete/', { key: payload })
    },
    modifyPhrase (context, payload) {
      return axios.patch('/api/phrase/modify/', payload)
    },
    registerPhrase (context, payload) {
      return axios.post('/api/phrase/create', payload)
    },
    phrasesLanguage (context, payload) {
      return axios.post('/api/phrases/all', {locale: payload})
    }
  }
}

export default languages



// WEBPACK FOOTER //
// app/javascript/src/store/language.js